import React from 'react';
import { Col, Row, ListGroup } from 'react-bootstrap';
import LoginEntry from './login-entry';
import Postit from '../main/postit';
import LargeCard from '../main/large-card';
import Navbar from '../navigation/navbar';
import TitleCard from '../main/title-card';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import translate from '../translate';

class Login extends React.Component {
    render() {
        let { location } = this.props;

        return (
            <Navbar nav={false}>
                <Row>
                    <LeftSide>
                        <TitleCard
                            title={[
                                this.props.strings.title1,
                                this.props.strings.title2,
                            ]}
                        />
                    </LeftSide>
                    <Col xs={6} sm={6} md={6} lg={6} className="col-middle">
                        <LoginEntry location={location} />
                    </Col>
                    <RightSide>
                        <Postit title={this.props.strings.infoTitle}>
                            {this.props.strings.infoText}
                        </Postit>
                    </RightSide>
                </Row>
            </Navbar>
        );
    }
}

export default translate('LoginForm')(Login);
